import { render, staticRenderFns } from "./FinalTyepCard.vue?vue&type=template&id=b2163932&scoped=true&"
import script from "./FinalTyepCard.vue?vue&type=script&lang=js&"
export * from "./FinalTyepCard.vue?vue&type=script&lang=js&"
import style0 from "./FinalTyepCard.vue?vue&type=style&index=0&id=b2163932&prod&lang=css&"
import style1 from "./FinalTyepCard.vue?vue&type=style&index=1&id=b2163932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2163932",
  null
  
)

export default component.exports